/**
 * @generated SignedSource<<274449a41f2484a331945aa39fdc50da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RaffleStatus = "LOSER" | "ONGOING" | "WINNER" | "%future added value";
export type raffleIndexEnterMutation$variables = {
  hubId: string;
};
export type raffleIndexEnterMutation$data = {
  readonly raffleEnter: {
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
    readonly status: RaffleStatus;
    readonly user: {
      readonly id: string;
    };
  };
};
export type raffleIndexEnterMutation = {
  response: raffleIndexEnterMutation$data;
  variables: raffleIndexEnterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*:: as any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "hubId",
            "variableName": "hubId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Raffle",
    "kind": "LinkedField",
    "name": "raffleEnter",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": (v2/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": (v2/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "raffleIndexEnterMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "raffleIndexEnterMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "c521ea40bea11ca247885243283881d9",
    "id": null,
    "metadata": {},
    "name": "raffleIndexEnterMutation",
    "operationKind": "mutation",
    "text": "mutation raffleIndexEnterMutation(\n  $hubId: UUID!\n) {\n  raffleEnter(input: {hubId: $hubId}) {\n    id\n    status\n    hub {\n      id\n    }\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2f969b2b2bb63512f8802d6752587da";

export default node;
